/* global G */

import { setKey } from 'lib/util'
import redirect from 'lib/hook/router/redirect'

/**
 * Back Or Redirect Hook
 *
 * Clears the module's UNDO state and, if there is history, calls the native adapter's back method.
 * If there is no history, calls the {@link redirect} sequence.
 *
 * @param {Object} obj  the current module composition object
 * @returns {function(...[*]): Promise<*[]>}
 */
const back = obj => async (...args) => {
  const router = obj[G.ADAPTER][G.ROUTER]
  setKey(null, G.UNDO, obj[G.STATE][G.ACTION][G.STATE])

  if (router.hasHistory()) {
    await router.back()
  } else {
    await redirect(obj)(args)
  }
  return args
}

export default back
